import React, { useState } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";
import CapitalPage from "./components/CapitalPage";
import TradesPage from "./components/TradesPage";
import SummaryPage from "./components/SummaryPage";
import PositionManager from "./components/PositionManager";
import { useTrades, useCapital } from "./useJournal";

const TABS = [
  { id:"positions", label:"Position Manager", icon:"📊" },
  { id:"trades",    label:"Trades",           icon:"📋" },
  { id:"summary",   label:"Summary",           icon:"📈" },
  { id:"capital",   label:"Capital",           icon:"💰" },
];

function JournalInner() {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("positions");
  const { trades } = useTrades();
  const { totalCapital } = useCapital();

  if (!user) return <LoginPage />;

  const openCount = trades.filter(t=>t.status==="open").length;
  const closedCount = trades.filter(t=>t.status==="closed").length;

  return (
    <div style={{fontFamily:"'Inter',-apple-system,sans-serif",background:"#f9fafb",minHeight:"100vh"}}>
      <div style={{background:"white",borderBottom:"1px solid #e5e7eb",padding:"0 24px",display:"flex",alignItems:"center",justifyContent:"space-between",height:52,position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <a href="/" style={{textDecoration:"none",color:"#9ca3af",fontSize:13}}>← Scanner</a>
          <span style={{fontWeight:800,fontSize:16,color:"#111827"}}>Champion Trader</span>
          <span style={{fontSize:12,color:"#9ca3af"}}>Journal</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:20,fontSize:12,color:"#6b7280"}}>
          <span>Capital: <strong style={{color:"#111827"}}>₹{(totalCapital/100000).toFixed(1)}L</strong></span>
          <span>Open: <strong style={{color:"#1d4ed8"}}>{openCount}</strong></span>
          <span>Closed: <strong style={{color:"#16a34a"}}>{closedCount}</strong></span>
          <span style={{color:"#9ca3af"}}>{user.displayName||user.email}</span>
          <button onClick={logout} style={{padding:"5px 12px",borderRadius:6,border:"1px solid #e5e7eb",background:"white",cursor:"pointer",fontSize:12,color:"#6b7280"}}>Sign out</button>
        </div>
      </div>

      <div style={{background:"white",borderBottom:"1px solid #e5e7eb",padding:"0 24px",display:"flex"}}>
        {TABS.map(tab=>(
          <button key={tab.id} onClick={()=>setActiveTab(tab.id)} style={{padding:"12px 20px",border:"none",cursor:"pointer",background:"transparent",fontSize:13,fontWeight:600,color:activeTab===tab.id?"#1d4ed8":"#6b7280",borderBottom:activeTab===tab.id?"2px solid #1d4ed8":"2px solid transparent",display:"flex",alignItems:"center",gap:6}}>
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div style={{padding:"24px 16px"}}>
        {activeTab==="positions"&&<PositionManager />}
        {activeTab==="trades"&&<TradesPage />}
        {activeTab==="summary"&&<SummaryPage />}
        {activeTab==="capital"&&<CapitalPage />}
      </div>
    </div>
  );
}

export default function JournalApp() {
  return <AuthProvider><JournalInner /></AuthProvider>;
}
